/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Ocr_Frame_Count_WarningInputs */

const en_ocr_frame_count_warning = /** @type {(inputs: Ocr_Frame_Count_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This will process approximately ${i?.count} frames. Higher sampling rates process faster but may miss short text.`)
};

const fr_ocr_frame_count_warning = /** @type {(inputs: Ocr_Frame_Count_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ce programme traitera environ ${i?.count} images. Des fréquences d'échantillonnage plus élevées permettent un traitement plus rapide, mais peuvent ne pas inclure de texte court.`)
};

const de_ocr_frame_count_warning = /** @type {(inputs: Ocr_Frame_Count_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dabei werden ungefähr ${i?.count} Frames verarbeitet. Höhere Abtastraten beschleunigen die Verarbeitung, können aber kurze Texte übersehen.`)
};

const it_ocr_frame_count_warning = /** @type {(inputs: Ocr_Frame_Count_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Questo elaborerà circa ${i?.count} fotogrammi. Frequenze di campionamento più elevate elaborano più velocemente ma potrebbero non essere sufficienti testi brevi.`)
};

const ru_ocr_frame_count_warning = /** @type {(inputs: Ocr_Frame_Count_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Эта программа обработает приблизительно ${i?.count} кадров. Более высокие частоты дискретизации обрабатывают данные быстрее, но могут пропустить короткий текст.`)
};

const es_ocr_frame_count_warning = /** @type {(inputs: Ocr_Frame_Count_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esto procesará aproximadamente ${i?.count} fotogramas. Las frecuencias de muestreo más altas procesan más rápido, pero pueden omitir texto corto.`)
};

const zh_cn2_ocr_frame_count_warning = /** @type {(inputs: Ocr_Frame_Count_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`这将处理大约 ${i?.count} 帧。更高的采样率处理速度更快，但可能会遗漏短文本。`)
};

const ja_ocr_frame_count_warning = /** @type {(inputs: Ocr_Frame_Count_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`これにより、約${i?.count}フレームが処理されます。サンプリングレートが高いほど処理速度は速くなりますが、短いテキストが欠落する可能性があります。`)
};

const hi_ocr_frame_count_warning = /** @type {(inputs: Ocr_Frame_Count_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`यह लगभग ${i?.count} फ्रेम संसाधित करेगा। उच्च सैंपलिंग दरें तेजी से संसाधित होती हैं लेकिन छोटे टेक्स्ट छूट सकते हैं।`)
};

const pt_pt2_ocr_frame_count_warning = /** @type {(inputs: Ocr_Frame_Count_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Isso processará aproximadamente ${i?.count} quadros. Taxas de amostragem mais altas processam mais rapidamente, mas podem perder textos curtos.`)
};

/**
* | output |
* | --- |
* | "This will process approximately {count} frames. Higher sampling rates process faster but may miss short text." |
*
* @param {Ocr_Frame_Count_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_frame_count_warning = /** @type {((inputs: Ocr_Frame_Count_WarningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Frame_Count_WarningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_frame_count_warning(inputs)
	if (locale === "de") return de_ocr_frame_count_warning(inputs)
	if (locale === "it") return it_ocr_frame_count_warning(inputs)
	if (locale === "ru") return ru_ocr_frame_count_warning(inputs)
	if (locale === "es") return es_ocr_frame_count_warning(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_frame_count_warning(inputs)
	if (locale === "ja") return ja_ocr_frame_count_warning(inputs)
	if (locale === "hi") return hi_ocr_frame_count_warning(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_frame_count_warning(inputs)
	return en_ocr_frame_count_warning(inputs)
});